import { validateDateString } from '@funnels/utils';

export function validateStartDate(value: any) {
  const errors = validateDateString()(value);

  if (errors) {
    return errors;
  } else {
    const valueMs = new Date(value).getTime();
    const now = new Date();
    now.setDate(0);
    const firstDayWithCurrentMonthMs = now.getTime();

    if (valueMs < firstDayWithCurrentMonthMs) {
      return 'Please enter a start date in the future';
    }
  }

  return;
}

export function validateEndDate(startDateValue: string | undefined, isOptional?: boolean) {
  return (value: any) => {
    const errors = validateDateString('Date value is incorrect.', isOptional)(value);

    if (errors) {
      return errors;
    } else {
      const valueMs = new Date(value).getTime();

      if (startDateValue) {
        const startDateValueMs = new Date(startDateValue).getTime();

        if (startDateValueMs >= valueMs) {
          return 'Please enter an end date after the start date';
        }
      }
    }

    return;
  };
}
